/* @flow */
import Link from 'components/Link.jsx';
import React from 'react';

import './styles/NavItem.scss';

class NavItem extends React.Component {
  render() {
    return (
      <li className="NavItem">
        <Link
          {...this.props}
          onlyActiveOnIndex
          className="NavItem-link"
          activeClassName="NavItem-link-active"
          eventElementName="NavItem-link">
          {this.props.children}
        </Link>
      </li>
    );
  }
}

export default NavItem;



// WEBPACK FOOTER //
// ./src/components/NavItem.jsx